<template>
  <span class="d-flex align-items-center">
    <span>
      <span :id="`filter-${field.key}`" variant="primary">
        <i class="ri ri-filter-2-fill mr-2"></i
      ></span>
      <b-popover :target="`filter-${field.key}`" triggers="hover focus">
        <div class="d-flex flex-column">
          <b-form-radio-group
            :value="field.filter.operator"
            @change="$emit('operator-change', $event)"
            :options="operators"
            stacked
            :checked="field.filter.operator"
          ></b-form-radio-group>
        </div>
      </b-popover>
    </span>
    <input
      :value="field.filter.value"
      @keypress.enter="$emit('input', $event.target.value)"
      class="form-control"
      style="font-size:12px;padding-top:0px;padding-bottom:0px"
    />
  </span>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      operators: [
        {
          value: '$lk',
          text: 'مشابه',
        },
        {
          value: '$eq',
          text: 'مساوی',
        },
        {
          value: '$ne',
          text: 'نامساوی',
        },
        {
          value: '$startsWith',
          text: 'شروع با',
        },
        {
          value: '$endsWith',
          text: 'پایان با',
        },
      ],
    }
  },
}
</script>
